module.exports = __webpack_public_path__ + "static/dibiaofaze-050c230a64c5268d82168892003edbb1.jpg";